<template>
	<div class="left main main_white col-lg-10 col-md-10 col-xs-12">
		<h1 class="cat_title" :class="{ empty: numOfFavs == 0 }">
			המועדפים שלי
			<span>({{ numOfFavs }})</span>
			<div class="note">חשוב לדעת: ברשימת המועדפים מוצגים לך רק מוצרים שיש כרגע במלאי</div>
		</h1>
		<div class="title_symbol">
			<HEART />
		</div>
		<div class="row prod_has_remove empty-fav" v-if="numOfFavs == 0">
			<div class="empty-nice-img">
				<EMPTYFAV />
			</div>
			<h2 class="title">עוד אין לך רשימת מועדפים? זה חוסך זמן ומוסיף טעם...</h2>
			<div class="text">
				המועדפים באתר הם כמו המזווה שלך בבית: שווה לשים פה את חומרי הגלם היומיומיים וגם המיוחדים והאהובים יותר.
				ככה יהיה לך קל ומהיר למצוא אותם בכל הזמנה ולהפוך את הבישול למעניין יותר.
				<br />
				<br />
				<b>
					רק שנהיה סגורים על זה - מוסיפים מוצר למועדפים בלחיצה על ה-
					<HEART />
				</b>
			</div>
			<div class="bt_green">
				<router-link to="/"> לקנייה </router-link>
			</div>
		</div>
		<div class="row prod_has_remove" v-if="numOfFavs > 0">
			<div class="results_item toggleContainer active" v-for="(cat, index) in childCategories" :key="index">
				<h2 class="results_top ease">
					<a href="javascript:void(0);" onclick="toggle(this)">
						{{ cat.name }}
						<span>({{ getQuantityByCategory(cat.id) }})</span>
						<arrow-down />
					</a>
				</h2>
				<div class="results_open toggleInner" style="display: block">
					<div class="row">
						<product
							:product="product"
							v-for="product in getProductsByCategory(cat.id)"
							:key="product.id"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Product from "../Product/Product";
	/** SVG import  */
	import HEART from "../../assets/img/heart.svg";
	import EMPTYFAV from "../../assets/img/empty-fav.svg";
	import ArrowDown from "../../assets/img/arrow_down.svg";
	export default {
		data() {
			return {
				favProducts: this.$store.state.storedFavs,
			};
		},
		// mounted() {
		// 	if (this.favProducts.length === 0) {
		// 		this.getProducts();
		// 	}
		// },
		methods: {
			getCategory(id) {
				return this.$store.state.categories.find((cat) => cat.id == id);
			},
			getCatName(id) {
				let cat = this.getCategory(id);
				return cat.name;
			},
			getQuantityByCategory(id) {
				let q = 0;
				this.products.map((p) => {
					if (p.categories.includes(id)) {
						q++;
					}
				});
				return q;
			},
			// getProducts() {
			// 	const ids = JSON.stringify(this.$store.state.storedFavs);
			// 	this.$ajax({
			// 		method: "POST",
			// 		url: homeUrl + "ajax.php",
			// 		params: {
			// 			getProducts: "",
			// 			ids: ids,
			// 		},
			// 	}).then((res) => {
			// 		this.favProducts = res.data;
			// 	});
			// },
			getProductsByCategory(id) {
				return this.products.filter((p) => p.categories.includes(id));
			},
		},
		watch: {
			stateFavs(value) {
				this.favProducts = this.favProducts.filter((i) => value.includes(i));
			},
		},
		computed: {
			stateFavs() {
				return this.$store.state.storedFavs;
			},
			products: function () {
				return this.favProducts;
			},
			childCategories() {
				let cats = [];
				const keys = this.categories;
				keys.map((key) => {
					let cat = this.getCategory(key);
					if (typeof cat != "undefined" && cat.parent != 0) {
						cats.push(cat);
					}
				});
				return cats;
			},
			categories() {
				let categories = [];
				let main = this;
				this.products.map(function (product) {
					categories = categories.concat(product.categories);
				});
				let cats = categories.filter((v, i) => categories.indexOf(v) == i);
				cats.sort(function (a, b) {
					let aCat = main.getCategory(a);
					let bCat = main.getCategory(b);
					if (typeof aCat == "object" && typeof bCat == "object") {
						if (aCat.position < bCat.position) {
							return -1;
						}
						if (bCat.position < aCat.position) {
							return 1;
						}
					}
					return 0;
				});
				return cats;
			},
			numOfFavs() {
				return this.$store.state.storedFavs.length;
			},
		},
		components: {
			HEART,
			EMPTYFAV,
			ArrowDown,
			Product,
		},
	};
</script>

<style lang="scss" scoped>
@media (max-width: 480px) {
  .main_white {
    background: #efede9;
  }
  .results_open .row {
    padding-top: 7px;
  }
}
</style>